<template>
    <div>
        <h3 style="text-align: center">รายงาน VISA</h3>
        <div class="row form-group">
            <div class="col-4 text-right">ประเภท</div>
            <div class="col-6">
                <b-form-select :options="optionTypeview" v-model="search.typeview"></b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แผนก</div>
            <div class="col-6">
                <multiselect
                    :options="optionDepartment"
                    v-model="search.department"
                    label="department_name"
                    select-label=""
                    multiple
                    :closeOnSelect="false"
                    style="height: 100%"
                    deselectLabel=""
                    placeholder="แผนก"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                    v-model="search.employee"
                    :options="optionEmployee"
                    placeholder="พนักงาน"
                    multiple
                    :closeOnSelect="false"
                    style="height: 100%"
                    :show-labels="false"
                    :customLabel="employeeLabel"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">วันที่</div>
            <div class="col-6">
                <date-picker
                    v-model="search.date"
                    type="date"
                    :format="changeFormat"
                    :lang="lang"
                    class="w-100"
                    placeholder="วันที่" confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">สัญชาติ</div>
            <div class="col-6">
                <multiselect
                    v-model="search.nation"
                    :options="optionNationality"
                    label="name"
                    placeholder="ค้นหาสัญชาติ"
                    :show-labels="false"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="print" style="width: 25px"></icon>
                ตกลง
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker';
import moment from "moment";

export default {
    name: "FilterSalaryModal",
    components: {
        Multiselect, DatePicker
    },
    data() {
        return {
            search: {
                date: '',
                employee: [],
                department: [],
                nation: '',
                typeview: 0,
            },
            optionEmployee: [],
            optionDepartment: [],
            optionTypeview: [{value: 0, text: 'หมดอายุแล้ว'}, {value: 1, text: 'ยังไม่หมดอายุ'}],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            optionNationality: state => {
                return state.Common.passport_type
            }
        })
    },
    created() {
        this.getEmployeeAll();
        this.$store.dispatch("Employee/setEmployee");
        this.getDepartmentAll();
        this.$store.dispatch('Common/getPassportType');
    },
    methods: {
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res;
            })
        },
        submitData() {
            let data = {
                employee_no: this.search.employee,
                passport_type_id: this.search.nation ? this.search.nation.id : '',
                type_view: this.search.typeview,
                department_id: this.search.department,
                date: this.search.date ? moment(String(this.search.date)).format('Y-M-D') : '',
            };
            this.$emit("submit", data);
        },
        cancelData() {
            this.$emit("submit", false);
        },
        getDepartmentAll() {
            this.$store.dispatch("Department/getAllDepartment").then(res => {
                this.optionDepartment = res;
            })
        },
    }
}
</script>

<style scoped>

</style>
